import { useState } from 'react';

/**
 * Tracks hover state for the ECG toolbar's beat marker buttons. Holds a boolean in useState and returns it together with its setter.
 *
 * @returns The hover flag and its setter.
 */
const useBeatMarkerButton = () => {
  const [isHover, setIsHover] = useState(false);

  return { isHover, setIsHover };
};

export { useBeatMarkerButton };
